import api from './api';

export const userService = {
  // Get all users
  getAllUsers: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.accountId) params.append('accountId', filters.accountId);
    if (filters.sub) params.append('sub', filters.sub);
    if (filters.activeOnly) params.append('activeOnly', 'true');
    if (filters.limit) params.append('limit', filters.limit);

    const queryString = params.toString();
    const url = queryString ? `/users?${queryString}` : '/users';

    const response = await api.get(url);
    return response.data;
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  // Create new user
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Update user
  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  // Partially update user
  patchUser: async (id, userData) => {
    const response = await api.patch(`/users/${id}`, userData);
    return response.data;
  },

  // Delete user (optionally scoped to an account — removes account permissions first)
  deleteUser: async (id, accountId) => {
    const url = accountId ? `/users/${id}?accountId=${accountId}` : `/users/${id}`;
    const response = await api.delete(url);
    return response.data;
  },

  // Resend invitation
  reinviteUser: async (id) => {
    const response = await api.post(`/users/${id}/reinvite`);
    return response.data;
  },

  // Reset password (public — no auth required)
  resetPassword: async (email) => {
    const response = await api.post('/users/reset-password', { email });
    return response.data;
  }
};
